// S2-FE2: ProgressBar
import './ProgressBar.css';

export interface ProgressBarProps {
  value: number; // 0-100
  variant?: 'primary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
}

export function ProgressBar({ value, variant = 'primary', size = 'md' }: ProgressBarProps) {
  // Clamp value between 0 and 100
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div
      className={`airgent-progress airgent-progress-${size}`}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={`airgent-progress-fill airgent-progress-fill-${variant}`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
